export default "__VITE_ASSET__9yYFh$xG__"